import {BaseMuWidget} from "../BaseMuWidget";
import {PqmCL} from "../generated/PqmCL";
import {PqmProcData} from "./pqmTypes";
import {CachedPromise} from "../CachedPromise";
import {MuNamedWidgets, MuUi} from "mu-widget/lib/MuWidget";
import {PqmPackets} from "./PqmPackets";
import {RelatedAccountSelector} from "../components/RelatedAccountSelector";
import {UiComment} from "../UiComments";
import {PqmTicketList} from "./PqmTicketList";
import {TicketOverviewCL} from "../generated/TicketOverviewCL";
import {PqmFieldOrgDivision} from "./Fields/PqmFieldOrgDivision";
import {flashError, flashInfo} from "../Utils";
import {UiTabs} from "mu-widget/lib/UiTabs";
import {MultiUpload} from "../MultiUpload";
import {AttachList} from "../AttachList";

export class PqmTicketDetail extends BaseMuWidget
{
	public cl: PqmCL = new PqmCL();
	// @ts-ignore
	public pqmProcData: PqmProcData;

	// @ts-ignore
	ui: MuUi<{
		pqmDetail: HTMLAnchorElement,
	}>;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		inputs: PqmPackets,
		outputs: PqmPackets,
		comments: UiComment,
		procData: PqmTicketList,
		orgDivisionId: PqmFieldOrgDivision,
		tabs: UiTabs,
		attachNew: MultiUpload,
		attachList: AttachList,
	}>;

	cpOrgDivision = new CachedPromise(() => this.cl.withMessage('Načítám organizační jednotky').getOrgDivisions('*', true));
	private ticketId: number|null = null;
	private pqmItemId: number | null = null;
	// @ts-ignore
	private ticket: PqmProcData;
	private useAttaches: boolean = false;

	beforeIndex() {
		this.muRegisterEvent('saved');
		this.container.classList.add('pqm-ticket-detail', 'pqm-ticket-detail--hide-details');
		this.muAppendContent(`
			<div mu="tabs:UiTabs"></div>
			<div tab-label="Detail" mu="tDetail">
				<div class="display-flex-row">
					<h1 class="flex-grow-1" mu-bind="summary"></h1>
					<div class="text-center">
						<div mu=":.#state"><div class="badge" mu-bind="name;color:style.backgroundColor;color|bwContrasted:style.color"></div></div>
						<label class="whitespace-nowrap"><input type="checkbox" mu="cDetails" />&nbsp;Detaily</label>
						<a mu="pqmDetail" target="_blank" class="icon-before-pqm-item">Proces</a>
					</div>
				</div>
				<div class="pqm-ticket-detail__header" mu="roles">
					<span>
						<strong>Datum:</strong> <span mu="#dtCreate|date"></span>
					</span>
					<span>
						<strong>Zadavatel:</strong> <span mu="#customers"></span>
					</span>
					<span mu="solver:TicketAccountSelector#solverIds" mu-params='{"label":"Řešitel","useDelegate":true}' class="flex-grow-1"></span>
					<span mu="reader:TicketAccountSelector#readerIds" mu-params='{"label":"Na vědomí","useAdd":true}' class="flex-grow-1"></span>
				</div>
				<fieldset mu="startInfo">
					<legend>Základní údaje</legend>
					<div class="row form-group">
						<label class="col-3 control-label">Pro středisko</label>
						<div class="col-9">
							<div mu="orgDivisionId:PqmFieldOrgDivision"></div>
							<label><input type="checkbox" mu="ticketPerSolver" /> Pro každého řešitele vytvořit zvlášť požadavek </label>
						</div>
					</div>
					<!-- <div class="row form-group">
						<label class="col-3 control-label">Priorita</label>
						<div class="col-9">
							<div mu="priorityId:UiRadioList"></div>
						</div>
					</div> -->
				</fieldset>			
				<div mu="inputs:PqmPackets" mu-params='{"disabled": true}'></div>
				<div mu="outputs:PqmPackets"></div>
				<div class="buttons">
					<span class="btn btn-primary" mu="bSave">Uložit</span>
				</div>
				<div mu="comments:UiComment" mu-params='{"isRoot":true}'></div>
			</div>
			<div tab-label="Celé spuštění" mu="tProcData">
				<div mu="procData:PqmTicketList"></div>
				<div class="buttons">
					<span class="btn btn-danger" mu="bCancel">Stornovat celé spuštění</span>
				</div>`
				+ (this.useAttaches ? `<h2>Přílohy</h2>
				<div mu="attachList:AttachList"></div>
				<div mu="attachNew:MultiUpload"></div>
				<div class="buttons">
					<span class="btn btn-primary" mu="bAddAttach">Přidat přílohu</span>				
				</div>` : '')
				+ `<div 
			</div>
		`);
	}

	cDetails_change() {
		this.container.classList.toggle('pqm-ticket-detail--hide-details', !this.ui.cDetails.checked);
	}

	async afterIndex() {
	}

	async bCancel_click() {
		const widget = this.openInModal<CancelProcDataDialog>(
			"CancelProcDataDialog",
			"Opravdu stornovat celé spuštění?"
		);
		const reason = await widget.eventPromise('cancelProcData', null);
		if (reason !== null) {
			await this.cl.cancelProcData(this.pqmProcData.procDataId, reason);
			await this.doLoad(this.ticketId!);
			flashInfo('Spuštění bylo stornováno.');
		}
	}

	bindForm(data: any) {
		const layout: "create"|"edit" = data.layout || 'edit';
		data = this.pqmProcData = {
			cooperating: {},
			data: [],
			ticket: {},
			layout: layout,
			...data,
		};

		this.muNamedWidget.inputs.disabled = layout === "edit";

		this.muNamedWidget.inputs.muBindData(data.inputs);
		this.muNamedWidget.inputs.setData(data.data);

		if (layout === "edit") {
			this.muNamedWidget.outputs.muBindData(data.outputs);
			this.muNamedWidget.outputs.setData(data.data);

			this.muNamedWidget.comments.loadComments(data.ticketId);
		}

		this.muVisible(layout === "edit", ["roles", "outputs", "comments", "!startInfo"]);

		this.muBindData(data.ticket);
		if (data.ticket.pqmItem) {
			this.ui.pqmDetail.href = '/pqm/pqm-detail/' + data.ticket.pqmItem.id;
			this.ui.pqmDetail.title = data.ticket.pqmItem.name;
		}
		this.muVisible(!!data.ticket.pqmItem, 'pqmDetail');
	}

	async bSave_click() {
		let res: any = null;
		if (this.pqmProcData.layout === 'edit') {
			res = await this.cl.saveTicketAndProcData(
				this.muFetchData(),
				this.muNamedWidget.outputs.getData(),
				this.ticketId
			);

			await this.muNamedWidget.outputs.afterSave(res);
			res = await this.cl.ticketFinalize(res.ticketId);
			this.bindForm(res);
			this.doLoad(res.ticketId);
		} else {
			const orgDivisionId = this.muNamedWidget.orgDivisionId.getValue();
			if (!orgDivisionId) {
				flashError('Je potřeba vybrat středisko');
				this.muNamedWidget.orgDivisionId.muNamedWidget.value.openModal();
				return;
			}
			res = await this.cl.createTicketAndProcData(
				this.pqmItemId!,
				{
					orgDivisionId,
					ticketPerSolver: this.ui.ticketPerSolver.checked
				},
				this.muNamedWidget.inputs.getData()
			);

			if (res.multiple) {
				for (const item of res.res) {
					await this.muNamedWidget.inputs.afterSave(item);
					res = await this.cl.ticketFinalize(item.ticketId);
				}
			} else {
				await this.muNamedWidget.inputs.afterSave(res.res);
				res = await this.cl.ticketFinalize(res.res.ticketId);
			}
			// this.bindForm(res);
			this.doLoad(res.ticketId);
			this.muNamedWidget.tabs.selectTab('tProcData');
		}
		this.muDispatchEvent('saved', res.ticket);
	}

	async doLoad(id: number) {
		this.ticketId = id;
		const ticket = await this.cl.withMessage('Načítám požadavek', this.container)
			.getTicketAndProcDataWithDetailsFor(this.ticketId);
		this.ticket = ticket;
		this.bindForm(ticket);

		await this.reloadTicketTree();

		if (this.useAttaches) this.muNamedWidget.attachList.bindData({ procDataId: ticket.procDataId });

		return ticket;
	}

	async reloadTicketTree() {
		// proc data
		this.muNamedWidget.procData.loadItems(await (new TicketOverviewCL())
			.withMessage("Načítám detaily spuštění", this.ui.procData)
			.getProcData(this.ticket.procDataId));
	}

	async bAddAttach_click() {
		await this.muNamedWidget.attachNew.sendToBackend((ctx, send) => {
			ctx.url = this.rawUploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
				procDataId: this.ticket.procDataId,
				fileName: ctx.file.name,
				contentType: ctx.file.type,
				size: ctx.file.size,
			}));
			send();
		});
		this.muNamedWidget.attachNew.clear();
		flashInfo('Příloha byla uložena');
		await this.muNamedWidget.attachList.bindData();
	}

	async doNew(pqmItemId: number) {
		this.pqmItemId = pqmItemId;
		const data = await this.cl.withMessage('Načítám proces', this.container)
			.getStartData(pqmItemId);
		this.muNamedWidget.orgDivisionId.setValue(data.defaultOrgDivisionId.toString());
		this.pqmProcData = data;
		this.pqmProcData.layout = "create";
		this.bindForm(this.pqmProcData);
		this.muVisible(false, ['tProcData', 'tabs']);
	}
}

export class CancelProcDataDialog extends BaseMuWidget{
	beforeIndex() {
		this.muRegisterEvent('cancelProcData');
		this.muAppendContent(`
			<label>Důvod ke stornování</label>
			<div mu="reason:Htmlarea"></div>
			<div class="buttons">
				<span class="btn btn-danger" mu="bDoCancel">Stornovat celé spuštění</span>
				<span class="btn btn-default" mu-click="muRemoveSelf">Zavřít beze změn</span>
			</div>
		`);
	}

	bDoCancel_click() {
		this.muDispatchEvent('cancelProcData', this.muNamedWidget.reason.muFetchData());
		this.muRemoveSelf();
	}
}